<template>
    <div ref="scrollRef">
        <img :src="require('@/assets/img/knowledge/banner.png')" alt="" style="width: 100%" data-aos="zoom-out">
        <router-view @knowledgeSelect="knowledgeSelect"></router-view>
<!--        <knowledgeMenu @knowledgeSelect="knowledgeSelect"/>-->
    </div>
</template>

<script>
import knowledgeMenu from "../components/knowledgeMenu";
export default {
	components: {
	    knowledgeMenu
    },
	data() {
		return {

        }
	},
	mounted(){
        // this.$router.push({
		// 	path:'/knowledge/special'
		// })
	},
    methods:{
	    knowledgeSelect(src){
	        if (src.indexOf('/img') > -1){
	            return
            }
            this.$router.push({
                path:src
            })
        }
    }
}
</script>

<style lang="less" scoped>
    .introduce{
        width: 100%;
        height: 230px;
        padding: 30px 0;
        box-sizing: border-box;
        box-shadow: 0 10px 20px rgba(51, 51, 51, 0.26);
        &>div{
            width: 1145px;
            height: 182px;
            margin: 0 auto;
            box-sizing: border-box;
            border-left: 1px solid #e6e6e6;
            border-right: 1px solid #e6e6e6;
            display: flex;
            justify-content: space-between;
            position: relative;
            &>div{
                width: 360px;
                height: 100%;
                text-align: center;
                box-sizing: border-box;
                padding-top: 15px;
                font-size: 26px;
                letter-spacing: 4px;
                div{
                    margin-top: 3px;
                }
            }
            &>div:nth-child(2){
                width: 424px;
                height: 250px;
                position: absolute;
                top: -40px;
                left: 360px;
                background: #ed1c24;
                padding-top: 44px;
                box-sizing: border-box;
                box-shadow:rgba(51, 51, 51, 0.8) 0px 0px 10px ;
                div{
                    color: #fff;
                    line-height: 40px;
                }
            }
        }
    }
</style>
